import { Dispatch } from 'redux';
import { ChatFetchResult, ChatActions } from "./types";
import { normalize } from "normalizr";
import { chatSchema } from "../schema";
import { API } from '../../utils/AxiosInstance';
import { ApplicationState } from '..';

export function fetchChats(cohort: string) {
    return async (dispatch: Dispatch<ChatActions>) => {
        try {
            dispatch({ type: 'chats/fetch-request' });
            const response = await API.get('/coach_communications', { params: { cohort: cohort }});
            const data: ChatFetchResult = normalize(response.data, [chatSchema]);
            dispatch({ type: 'chats/fetch-success', data });
        } catch (e) {
            dispatch({ type: 'chats/fetch-error' });
        }
    }
}

export function createChat(cohort: string, message: string) {
    return async (dispatch: Dispatch<ChatActions>) => {
        try {
            dispatch({ type: 'chats/create-request' });
            const response = await API.post('/coach_communications', { cohort, message });
            const data: ChatFetchResult = normalize([response.data], [chatSchema]);
            dispatch({ type: 'chats/create-success', data });
        } catch (e) {
            dispatch({ type: 'chats/create-error' });
        }
    }
}

export function fetchChatUser(id: string) {
    return async (dispatch: Dispatch) => {
        try {
            const response = await API.get(`/coach_communications/${ id }`);
            dispatch<ChatActions>({ type: 'chats/chat-user', data: response.data.user });
        } catch (e) {

        }
    }
}

export function chatNotification({ i, t, u, m }: { i: string, t: string, u: string, m: string }) {
    return (dispatch: Dispatch, getState: () => ApplicationState) => {
        const { uiChatTab, users } = getState();
        if (uiChatTab.ids.indexOf(i) === -1) {
            if (!users[u]) {
                dispatch<any>(fetchChatUser(i));
            }

            dispatch<ChatActions>({ type: 'chats/chat-notification', data: {
                id: i,
                message: m,
                created_at: t,
                user: u
            } });


        }
    }
}
